import React from 'react';
import { colors } from '@/globalStyles';

const LineComponent = props => {
  const { id, primitiveProps, style, className } = props;
  const {
    start_point: { x: x1, y: y1 },
    end_point: { x: x2, y: y2 },
    outline_style,
  } = primitiveProps;
  const parsedStyle = JSON.parse(JSON.stringify(style));
  const styles = {
    ...parsedStyle,
    pointerEvents: className === 'decoration' ? 'none' : 'unset',
    fill: 'none',
    ...(!parsedStyle.stroke && { stroke: outline_style && outline_style.enabled && outline_style.color ? outline_style.color : colors.black }),
  };

  return <line className={className} id={id} x1={x1} y1={y1} x2={x2} y2={y2} style={styles} />;
};

export default LineComponent;
